import { useLayoutData } from "../../../../../../utils/contexts/LayoutContext"
import { topBarAvailable, topBarHasLeftData, topBarHasRightData } from "../../../../PartnerPortalLayout"
import MenuList from "./MenuList"

interface MobilNavbarProps {
  open: boolean
  close: () => void
}

const MobilNavbar = ({
  open,
  close
}: MobilNavbarProps) => {
  const { partnerSiteFull } = useLayoutData()

  return (
    <>
      <div className= {`offcanvas-mobile-menu ${open ? 'active' : ''}`} id="mobile-menu-overlay">
        <a onClick={() => close()} className="offcanvas-menu-close" id="mobile-menu-close-trigger">
          <i className="ion-android-close" />
        </a>
        <div className="offcanvas-wrapper">
          <div className="offcanvas-inner-content">
            <nav className="offcanvas-navigation" id="offcanvas-navigation">
              <ul>
                <MenuList closeMobilMenu={close} mobile />
              </ul>
            </nav>
            {topBarAvailable(partnerSiteFull) ? (
              <div className="offcanvas-widget-area">
                {topBarHasLeftData(partnerSiteFull) ? (
                  <div className="off-canvas-contact-widget">
                    <div className="header-contact-info">
                        <ul className="header-contact-info__list">
                          {partnerSiteFull?.content?.topBar?.items?.map((item, i) => {
                            if (!item.rightSide) {
                              return (
                                <li key={i} className={'d-block'}><i className={`fa ${item.ikon}`} />{item.title}</li>
                              )
                            }
                          })}
                        </ul>
                    </div>
                  </div>
                ) : null}

                {topBarHasRightData(partnerSiteFull) ? (
                  <div className="off-canvas-widget-social">
                    {partnerSiteFull?.content?.topBar?.items?.map((item, i) => {
                      if (item.rightSide) {
                        return (
                          <a key={i} href={item.link} target="_blank" rel="noreferrer"><i className={`fa ${item.ikon}`} /></a>
                        )
                      }
                    })}
                  </div>
                ) : null}
              </div>
            ) : null}
          </div>
        </div>
    </div>
    </>
  )
}

export default MobilNavbar